import React from 'react';
import Head from 'next/head';

interface SEOProps {
  title: string;
  description?: string;
  canonicalurl?: string;
  keywords?: string;
  ogImage?: string;
  robotIndex?: string | null;
  robotFollow?: string | null;
  children?: React.ReactNode;
}

function SEO(props: SEOProps) {
  const {
    children,
    title,
    canonicalurl,
    description,
    keywords,
    ogImage,
    robotIndex,
    robotFollow,
  } = props;

  const robotsContent = [robotIndex, robotFollow].filter(Boolean).join(', ');

  return (
    <Head>
      <title>{title}</title>
      {robotsContent && <meta name="robots" content={robotsContent} />}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalurl && <link rel="canonical" href={canonicalurl} />}

      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalurl} />
      <meta property="og:site_name" content="invideo" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta
        property="article:publisher"
        content="https://www.facebook.com/invideo.io/"
      />
      <meta property="fb:admins" content="198297767789959" />
      <meta property="fb:app_id" content="1907729596109046" />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="invideo" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:title" content={title} />

      {children}
    </Head>
  );
}

export default SEO;
